/**
 * <sticky-header> — toggles "is-scrolled" class on scroll past 8px.
 * The CSS in base.css applies background + border when scrolled.
 *
 * Also handles mega-menu hover/focus open/close.
 */

class StickyHeader extends globalThis.ThemeElement {
  connectedCallback() {
    this.threshold = parseInt(this.dataset.threshold || '8', 10);
    this.onScroll = globalThis.JunneTheme.throttle(this._onScroll.bind(this), 100);
    this.on(window, 'scroll', this.onScroll, { passive: true });
    this._onScroll();
    this._setupMegaMenu();
  }

  _onScroll() {
    if (window.scrollY > this.threshold) {
      this.classList.add('is-scrolled');
    } else {
      this.classList.remove('is-scrolled');
    }
  }

  _setupMegaMenu() {
    const triggers = this.$$('[data-mega-menu-trigger]');
    const panels = this.$$('[data-mega-menu-key]');
    if (!triggers.length) return;

    const openMenu = (key) => {
      for (const p of panels) {
        const isMatch = p.dataset.megaMenuKey === key;
        p.setAttribute('aria-hidden', isMatch ? 'false' : 'true');
      }
      for (const t of triggers) {
        t.setAttribute('aria-expanded', t.dataset.megaMenuTrigger === key ? 'true' : 'false');
      }
    };
    const closeAll = () => {
      for (const p of panels) p.setAttribute('aria-hidden', 'true');
      for (const t of triggers) t.setAttribute('aria-expanded', 'false');
    };

    for (const trigger of triggers) {
      this.on(trigger, 'pointerenter', () => openMenu(trigger.dataset.megaMenuTrigger));
      this.on(trigger, 'focus', () => openMenu(trigger.dataset.megaMenuTrigger));
      this.on(trigger, 'click', (e) => {
        e.preventDefault();
        const key = trigger.dataset.megaMenuTrigger;
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        if (expanded) closeAll(); else openMenu(key);
      });
    }
    this.on(this, 'pointerleave', closeAll);
    this.on(this, 'focusout', (e) => {
      if (!this.contains(e.relatedTarget)) closeAll();
    });
    this.on(window, 'keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });
  }
}

if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);
